<div class="notification-display" *ngIf="!(cookiesAccepted$ | async)" tabindex="-1">
    <div class="notification-display__wrapper">
        <div class="notification-display__text">
            <span>{{ 'NOTIFICATION_COOKIES_TEXT' | translate }}</span>
            <a
                class="link link--action dark:text-contrast-black"
                [routerLink]="cookieConsentLink | localize"
                (click)="closeMobileMenu()"
                >{{ 'NOTIFICATION_COOKIES_LINK_TEXT' | translate }}</a
            >
        </div>
        <div class="notification-display__button">
            <button class="btn btn--primary btn--square" (click)="onAcceptCookies()">
                {{ 'DIALOG_BUTTON_OK' | translate }}
            </button>
        </div>
    </div>
</div>
